import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Form,
  Input,
  FormGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import DateTime from 'react-datetime'
import "react-datetime/css/react-datetime.css"
import AsyncSelect from 'react-select/async'
import NumberFormat from 'react-number-format'
import Iframe from 'react-iframe'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import ReactSelect from 'components/Form/Select/Select'
import useForm from "lib/useForm"
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import {homepage} from '../../../../package.json';

const formSwal = withReactContent(Swal)

const confInicial = [
  {nome : 'A', total: '00,00', itens: '0', porc: '0', select: true},
  {nome : 'B', total: '00,00', itens: '0', porc: '0', select: true},
  {nome : 'C', total: '00,00', itens: '0', porc: '0', select: true}
]

const optionNome = [
  { id: 'A', title: 'A' },
  { id: 'B', title: 'B' },
  { id: 'C', title: 'C' },
  { id: 'D', title: 'D' },
  { id: 'E', title: 'E' },
  { id: 'F', title: 'F' },
  { id: 'G', title: 'G' },
  { id: 'H', title: 'H' },
  { id: 'I', title: 'I' },
  { id: 'J', title: 'J' },
  { id: 'K', title: 'K' },
  { id: 'L', title: 'L' },
  { id: 'M', title: 'M' },
  { id: 'N', title: 'N' },
  { id: 'O', title: 'O' },
  { id: 'P', title: 'P' },
  { id: 'Q', title: 'Q' },
  { id: 'R', title: 'R' },
  { id: 'S', title: 'S' },
  { id: 'T', title: 'T' },
  { id: 'U', title: 'U' },
  { id: 'V', title: 'V' },
  { id: 'W', title: 'W' },
  { id: 'X', title: 'X' },
  { id: 'Y', title: 'Y' },
  { id: 'Z', title: 'Z' }
]

const curvaConfigInicial = {
  op1NomeSelect: {id:'A', title: 'A'},
  op1Porcentagem: '50',
  op2NomeSelect: {id:'B', title: 'B'},
  op2Porcentagem: '30',
  op3NomeSelect: {id:'C', title: 'C'},
  op3Porcentagem: '20',
}

const CurvaABC = () => {

  const [form, , , onChangeSelect, onChangeDate]   = useForm([])
  const [config, , setConfig]                      = useForm(confInicial)
  const [curvaConfig, onChangeCurvaConfig, setCurvaConfig, onChangeSelectCurvaConfig] = useForm(curvaConfigInicial)
  
  const [loading, setLoading]             = useState(true)
  const [loadingTabela, setLoadingTabela] = useState(false)
  const [lojas, setLojas]                 = useState([])
  const [categorias, setCategorias]       = useState([])
  const [fornecedores, setFornecedores]   = useState([])
  // eslint-disable-next-line no-unused-vars
  const [vendedores, setVendedores]       = useState([])
  const [listaCurva, setListaCurva]       = useState([])
  const [listaOrigin, setListaOrigin]     = useState([])
  const [modalConfig, setModalConfig]     = useState(false)
  const [divResumo, setdivResumo]         = useState('d-none')
  const [pathPDF, setPathPDF]             = useState('')
  const [modalPrint, setModalPrint]       = useState(false);

  const colunas = [
    {
      dataField: 'fantasia',
      text: 'Loja',
      headerStyle: { cursor: 'text' },
      sort: true
    },
    {
      dataField: 'cod_barras',
      text: 'Cód barras',
      headerStyle: { cursor: 'text' }
    },
    {
      dataField: 'produto',
      text: 'Produto',
      headerStyle: { cursor: 'text' },
      sort: true
    },
    {
      dataField: 'fornecedor',
      text: 'Fornecedor',
      headerStyle: { cursor: 'text' },
      sort: true
    },
    {
      dataField: 'curva_qtvendida',
      text: 'Unidades',
      headerStyle: { cursor: 'text' },
      sort: true
    },
    {
      dataField: 'curva_totalvenda',
      text: 'Venda',
      headerStyle: { cursor: 'text' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'valor_ult_compra',
      text: 'Ultima compra',
      headerStyle: { cursor: 'text' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'prod_saldo',
      text: 'Saldo atual',
      headerStyle: { cursor: 'text' },
    },
    {
      dataField: 'curva_classe',
      text: 'Classe',
      headerStyle: { cursor: 'text' },
      sort: true,
      style: (cell, row, rowIndex, colIndex) => {

        if (cell == 'A') {
          return {
            color: '#2E7D32',
            fontWeight: 800
          };
        }
        if (cell == 'B') {
          return {
            color: '#FF8F00',
            fontWeight: 800
          };
        }
        return {
          color: '#DD2C00',
          fontWeight: 800
        };
      },
    },
    {
      dataField: 'curva_classificacao',
      text: 'Classificação',
      headerStyle: { cursor: 'text' },
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      }
    },
  ]

  const tipoCurva = [
    {id: 'analisa_curva_custom', title: 'Representatividade de venda'},
    {id: 'lucro', title: 'Lucro'},
    {id: 'analisa_curva_custom_item', title: 'Unidades vendidas'}
  ]

  const listaLojas = () => {
    let lista = [{id: 0, title: 'TODAS'}]
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success === 'S' && ret.lista !== ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setLojas(lista)
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  const listarCategorias = () => {
    const url     = rotas.categoriaSelect;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success === 'S' && ret.lista !== '' && ret.lista !== null) {
        let lista = [];
        ret.lista.forEach(lst => {
          lista.push({ id: lst.categoria_id, title: lst.categoria });
        });
        setCategorias(lista);
      }
      setLoading(false)
    })
  }

  const listarFornecedores = () => {
    const url     = rotas.fornecedorProduto
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success === 'S' && ret.lista !== '' && ret.lista !== null) {
        let lista = [];
        ret.lista.forEach(lst => {
          lista.push({ id: lst.fornecedor_id, title: lst.fornecedor });
        });
        setFornecedores(lista);
      }
      setLoading(false)
    })
  }

  const pesquisaProduto = (produto) => {
    if (produto.length >= 3) {
      const url = rotas.filtroProdutoRelatorio;
      const retorno = rest.get(url + '?produto=' + produto);
      let rProdutos = [];
      return retorno.then(ret => {
        ret.lista.forEach(produto => {
          rProdutos.push({ value: produto.produto_id, label: produto.produto, cod_barras: produto.cod_barras || '' })
        })
        return (rProdutos);
    })
    }
  }

  const listarVendedores = () => {
    const url     = rotas.vendedor;
    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success && ret.success === 'S' && ret.lista !== '' && ret.lista !== null) {
        let lista = [];
        ret.lista.forEach(lst => {
          lista.push({ id: lst.vendedor_id, title: lst.vendedor });
        });
        setVendedores(lista);
      }
    })
  }

  const listaConfig = () =>{
    const url     = rotas.curvaAbc+'curvas.php'
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success === 'S' && ret.lista !== '' && ret.lista !== null) {
        let lista = [];
        ret.lista.forEach(lst => {
          lista.push( {
            op1NomeSelect: {id:lst.classe1, title: lst.classe1},
            op1Porcentagem: lst.valor1,
            op2NomeSelect: {id:lst.classe2, title: lst.classe2},
            op2Porcentagem: lst.valor2,
            op3NomeSelect: {id:lst.classe3, title: lst.classe3},
            op3Porcentagem: lst.valor3,
          })
        });
        setCurvaConfig(lista[0]);
      }
      setLoading(false)
    })
  }

  const clikClasses = (id) => {
    let linha       = config[id]
    linha['select'] = !linha['select']

    setConfig({...config, [id] : linha})
  }

  function verificaRepeticao() {
    const ids = new Set();
    for (const key in curvaConfig) {
      if (key.endsWith('NomeSelect')) {
        const id = curvaConfig[key].id;
        if (ids.has(id)) {
          // console.error(`Erro: O id "${id}" já foi utilizado. Certifique-se de que os ids são únicos.`);
          return false;
        }
        ids.add(id);
      }
    }
    return true;
  }

  const submitConfigClasses = () => {
    if (verificaRepeticao()) {
      console.log(curvaConfig);

      try {
        const url     = rotas.curvaAbc+"config.php"
        const retorno = rest.post(url, curvaConfig)

        retorno.then(ret => {
          console.log(ret)
          if (ret.success && ret.success === 'S') {
            setListaCurva([])
            setdivResumo('d-none')
            formSwal.fire('Salvo!', ret.msg, 'success')
          }else{
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        })

      } catch (error) {
        console.log(error)
        formSwal.fire('Erro!', error, 'error')
      }
    } else {
      formSwal.fire('Erro!', 'Curvas com o mesmo nome . Certifique-se de que os nomes das curvas sejam únicos.', 'error')
    }
  }

  const atualizaClasse = () => {
    let segundaLista = listaOrigin

    config.forEach((item) => {
      if (!item.select) {
        segundaLista = segundaLista.filter((curva) => curva.curva_classe !== item.nome);
      }
    })
    setListaCurva(segundaLista)
  }

  const configPerfil = () => { 
    console.log('teste');
    setModalConfig(true)
  }

  const imprimirCurvaAbc = () => {
    if (listaCurva.length > 0) {
      
      let dados = {
        rede:     sessionStorage.getItem('rede'),
        usuario:  sessionStorage.getItem('usuario'),
        dataI:    form['inicio'],
        dataF:    form['final'],
        lista:    listaCurva,
        total:    config
      }
  
      try{
        const url     = rotas.curvaAbc+"pdf/"
        const retorno = rest.post(url, dados);
  
        retorno.then(ret => {
          if (ret.success && ret.success === 'S' && ret.path !== '' && ret.path !== null) {
            let caminho = url.split('/');
            let caminhoPDF = '';
  
            for(let x = 0 ; x < caminho.length -1 ; x++){
              if(caminhoPDF === ''){
                caminhoPDF = caminho[x]; 
              }else{
                caminhoPDF = caminhoPDF + '/' + caminho[x];
              }
            }
            setPathPDF( homepage + '/' + caminhoPDF + ret.path);
            setModalPrint(true);
  
          } else {
            console.log(ret);
            // Swal.fire('Erro', 'Erro na geração da impresão', 'error');
          }
        })
      }catch(err){
        console.log(err)
      }
    }
  }

  const pesquisaSubmit = (e) => {
    e.preventDefault()

    setdivResumo('d-none')
    setLoadingTabela(true)

    console.log(form)

    let dados = {
      form :  form,
      config: curvaConfig
    }

    const url     = rotas.curvaAbc
    const retorno = rest.post(url, dados)

    try {
      retorno.then(ret => {
        if (ret.success && ret.success === 'S' && ret.lista.length > 0){
          setListaCurva(ret.lista)
          setListaOrigin(ret.lista)
          setConfig(ret.total)
          setdivResumo('d-block')
        }else{
          setListaCurva([])
          setListaOrigin([])
          setConfig(confInicial)
          if (ret.aviso) {
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        }
        setLoadingTabela(false)
      })
    } catch (error) {
      console.log(error);
      setListaCurva([])
      setListaOrigin([])
      setLoadingTabela(false)
    }
  }

  useEffect(() => {
    listaLojas()
    listarCategorias()
    listarFornecedores()
    listarVendedores()
    listaConfig()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    atualizaClasse()
  }, [config]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return ( <Loading tipo='paginas' /> )
  } else {
    return (
      <div className="content" key="585">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>ESTATÍSTICA CURVA ABC</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="border p-3">
                    <Form onSubmit={pesquisaSubmit}>
                      <Container>
                        <Row>

                          <Col md='4'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                isMulti
                                name          = "lojas"
                                placeholder   = "Selecione a Loja"
                                options       = {lojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
                          
                          <Col md="4">
                            <FormGroup className="mb-0">
                            <AsyncSelect
                              isMulti
                              cacheOptions 
                              defaultOptions 
                              id              = "selectProdutos"
                              name            = "selectProdutos"
                              classNamePrefix = "react-select"
                              placeholder     = "Selecione o Produto"
                              loadOptions        = {pesquisaProduto}
                              onChange           = {onChangeSelect('produtoSelect')}
                              onClick            = {form.produtoSelect ? form.produto_id = form.produtoSelect.id : ''}
                              noOptionsMessage   = {() => "Nenhum produto encontrado"}
                              loadingMessage     = {() => "Buscando..."}
                              formatOptionLabel  = {(opt) => (
                                <div>
                                  <div style={{ fontSize: '13px' }}>{opt.label}</div>
                                  {opt.cod_barras && <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}><i className="ti ti-barcode" style={{ fontSize: '12px', marginRight: '4px' }} aria-hidden="true" />{opt.cod_barras}</div>}
                                </div>
                              )}
                            />
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.inicio}
                                onChange      = {onChangeDate('inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.final}
                                onChange      = {onChangeDate('final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = 'slecFornecedor'
                                name            = "selectFornecedor"
                                placeholder     = "Selecione o Fornecedor"
                                options         = {fornecedores}
                                onChange        = {onChangeSelect('fornecedorSelect')}
                                onClick         = {form.fornecedorSelect ? form.fornecedor_id = form.fornecedorSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = "selectCategoria"
                                name            = "selectCategoria"
                                classNamePrefix = "react-select"
                                placeholder     = "Selecione a Categoria"
                                options         = {categorias}
                                onChange        = {onChangeSelect('categoriaSelect')}
                                onClick         = {form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                id              = "selectTipoCurva"
                                name            = "selectTipoCurva"
                                classNamePrefix = "react-select"
                                placeholder     = "Selecione tipo da da curva"
                                options         = {tipoCurva}
                                onChange        = {onChangeSelect('selectTipoCurva')}
                                onClick         = {form.selectTipoCurva ? form.tipoCurva = form.selectTipoCurva.id : ''}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col md='3'>
                            <FormGroup className="mt-3">
                              <Button 
                                color   = "info"
                                onClick = {configPerfil}
                              >
                                Personalizar
                                <i className="nc-icon nc-settings-gear-65 pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>

                          <Col md='6' style={{ display: "flex", justifyContent: "center", }}>
                            <FormGroup className="mt-3">
                              <Button 
                                color   = "warning"
                                onClick = {imprimirCurvaAbc}
                              >
                                IMPRIMIR
                                <i className="nc-icon nc-single-copy-04 pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>
                          
                          <Col md="3">
                            <FormGroup className="mt-3" style={{ display: "flex", justifyContent: "right", }}>
                              <Button color="success" >
                                Gerar
                                <i className="nc-icon nc-zoom-split pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>
                        </Row>

                      </Container>
                    </Form>

                    {
                      loadingTabela ?  <Loading tipo='componente' /> 
                      :
                        <BootstrapTable
                          striped
                          keyField          = 'curva_classificacao'
                          data              = {listaCurva}
                          columns           = {colunas}
                          noDataIndication  = "Nenhum registro encontrado"
                          pagination        = {paginationFactory({
                                                sizePerPage: 20,
                                                hideSizePerPage: true,
                                                hidePageListOnlyOnePage: true,
                                                showTotal: false,
                                              })}
                          rowStyle          = {{ cursor: "pointer" }}                          
                        />
                    }

                    <Container className={divResumo}>
                      <Row>
                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                              <FormGroup check inline className="mb-0">
                                <Label check>
                                  <Input
                                    id        = "p1value"
                                    name      = "p1value"
                                    type      = "checkbox"
                                    checked   = {config[0].select}
                                    onChange  = {() => {clikClasses(0)}}
                                  />
                                  <span className="form-check-sign bg-success" />{config[0].nome}
                                </Label>
                              </FormGroup>{" "}
                              </span>
                            </Col>
                            <Row>
                              <Col md = '5'>
                              <FormGroup className="text-center">
                                <Label for="configTotal">Total</Label>
                                <Input
                                  disabled
                                  id    = "configTotal"
                                  name  = "configTotal"
                                  type  = "text"
                                  value = {config[0].total}
                                />
                              </FormGroup>
                              </Col>
                              <Col md='3'>
                              <FormGroup className="text-center">
                                <Label for="configItens">Itens</Label>
                                <Input
                                  disabled
                                  id    = "configItens"
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[0].itens}
                                />
                              </FormGroup>
                              </Col>
                              <Col md='4'>
                              <FormGroup className="text-center">
                                <Label for="configPorcento">%</Label>
                                <Input
                                  disabled
                                  id    = "configPorcento"
                                  name  = "configPorcento"
                                  type  = "text"
                                  value = {config[0].porc}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                              <FormGroup check inline className="mb-0">
                                <Label check>
                                  <Input
                                    id        = "p2value"
                                    name      = "p2value"
                                    type      = "checkbox"
                                    checked   = {config[1].select}
                                    onChange  = {() => {clikClasses(1)}}
                                  />
                                  <span className="form-check-sign bg-warning" />{config[1].nome}
                                </Label>
                              </FormGroup>{" "}
                              </span>
                            </Col>
                            <Row>
                              <Col md='5'>
                              <FormGroup className="text-center">
                                <Label for="configItens">Total</Label>
                                <Input
                                  disabled
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[1].total}
                                />
                              </FormGroup>
                              </Col>
                              <Col md='3'>
                              <FormGroup className="text-center">
                                <Label for="configItens">Itens</Label>
                                <Input
                                  disabled
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[1].itens}
                                />
                              </FormGroup>
                              </Col>
                              <Col md='4'>
                              <FormGroup className="text-center">
                                <Label for="configItens">%</Label>
                                <Input
                                  disabled
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[1].porc}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                              <FormGroup check inline className="mb-0">
                                <Label check>
                                  <Input
                                    id        = "p3value"
                                    name      = "p3value"
                                    type      = "checkbox"
                                    checked   = {config[2].select}
                                    onChange  = {() => {clikClasses(2)}}
                                  />
                                  <span className="form-check-sign bg-danger" />{config[2].nome}
                                </Label>
                              </FormGroup>{" "}
                              </span>
                            </Col>
                            <Row>
                              <Col md='5'>
                              <FormGroup className="text-center">
                                <Label for="configItens">Total</Label>
                                <Input
                                  disabled
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[2].total}
                                />
                              </FormGroup>
                              </Col>
                              <Col md='3'>
                              <FormGroup className="text-center">
                                <Label className="center" for="configItens">Itens</Label>
                                <Input
                                  disabled
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[2].itens}
                                />
                              </FormGroup>
                              </Col>
                              <Col md='4'>
                              <FormGroup className="text-center">
                                <Label for="configItens">%</Label>
                                <Input
                                  disabled
                                  name  = "configItens"
                                  type  = "text"
                                  value = {config[2].porc}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>
                      </Row>

                    </Container>
                  </div>

                  <Modal
                    key     = 'modalCurva'
                    size    = 'lg'
                    isOpen  = {modalConfig}
                  >
                    <ModalHeader>Personalize a baixo o nome e porcentagem das suas curvas</ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col md="4">
                          <Card>
                              <CardBody>
                                <CardTitle className="text-center" style={{ background: '#A5D6A7'}} >1° curva</CardTitle>
                                <FormGroup className="text-center">
                                  <Label className="center" for="op1Nome">Nome</Label>
                                    <ReactSelect
                                      id              = "op1Nome"
                                      name            = "op1Nome"
                                      classNamePrefix = "react-select"
                                      placeholder     = "A"
                                      options         = {optionNome}
                                      defaultValue    = {curvaConfig.op1NomeSelect}
                                      onChange        = {onChangeSelectCurvaConfig('op1NomeSelect')}
                                    />
                                </FormGroup>
                                <FormGroup className="text-center">
                                  <Label className="center" for="op1Porcentagem">Porcentagem</Label>
                                    <NumberFormat
                                      fixedDecimalScale
                                      id                = "op1Porcentagem"
                                      name              = "op1Porcentagem"
                                      className         = {"form-control text-success"}
                                      placeholder       = "0.00"
                                      maxLength         = {20}
                                      decimalScale      = {2}
                                      allowNegative     = {false}
                                      suffix            = {' %'}
                                      decimalSeparator  = {','}
                                      value             = {curvaConfig.op1Porcentagem}
                                      onChange          = {onChangeCurvaConfig('op1Porcentagem')}
                                    />
                                </FormGroup>
                              </CardBody>
                          </Card>
                        </Col>

                        <Col md="4">
                          <Card>
                              <CardBody>
                                <CardTitle className="text-center" style={{ background: '#FFE082'}} >2° curva</CardTitle>
                                <FormGroup className="text-center">
                                  <Label className="center" for="op2Nome">Nome</Label>
                                    <ReactSelect
                                      id              = "op2Nome"
                                      name            = "op2Nome"
                                      classNamePrefix = "react-select"
                                      placeholder     = "A"
                                      options         = {optionNome}
                                      defaultValue    = {curvaConfig.op2NomeSelect}
                                      onChange        = {onChangeSelectCurvaConfig('op2NomeSelect')}
                                    />
                                </FormGroup>
                                <FormGroup className="text-center">
                                  <Label className="center" for="op2Porcentagem">Porcentagem</Label>
                                    <NumberFormat
                                      fixedDecimalScale
                                      id                = "op2Porcentagem"
                                      name              = "op2Porcentagem"
                                      className         = {"form-control text-warning"}
                                      placeholder       = "0.00"
                                      maxLength         = {20}
                                      decimalScale      = {2}
                                      allowNegative     = {false}
                                      suffix            = {' %'}
                                      decimalSeparator  = {','}
                                      value             = {curvaConfig.op2Porcentagem}
                                      onChange          = {onChangeCurvaConfig('op2Porcentagem')}
                                    />
                                </FormGroup>
                              </CardBody>
                          </Card>
                        </Col>

                        <Col md="4">
                          <Card>
                              <CardBody>
                                <CardTitle className="text-center" style={{ background: '#FFAB91'}} >3° curva</CardTitle>
                                <FormGroup className="text-center">
                                  <Label className="center" for="op3Nome">Nome</Label>
                                    <ReactSelect
                                      id              = "op3Nome"
                                      name            = "op3Nome"
                                      classNamePrefix = "react-select"
                                      placeholder     = "A"
                                      options         = {optionNome}
                                      defaultValue    = {curvaConfig.op3NomeSelect}
                                      onChange        = {onChangeSelectCurvaConfig('op3NomeSelect')}
                                    />
                                </FormGroup>
                                <FormGroup className="text-center">
                                  <Label className="center" for="op3Porcentagem">Porcentagem</Label>
                                    <NumberFormat
                                      fixedDecimalScale
                                      id                = "op3Porcentagem"
                                      name              = "op3Porcentagem"
                                      className         = {"form-control text-danger"}
                                      placeholder       = "0.00"
                                      maxLength         = {20}
                                      decimalScale      = {2}
                                      allowNegative     = {false}
                                      suffix            = {' %'}
                                      decimalSeparator  = {','}
                                      value             = {curvaConfig.op3Porcentagem}
                                      onChange          = {onChangeCurvaConfig('op3Porcentagem')}
                                    />
                                </FormGroup>
                              </CardBody>
                          </Card>
                        </Col>
                      </Row>

                    </ModalBody>
                    <ModalFooter style={{ display: "flex", justifyContent: "center", }}>
                      <Row>
                        <Col className="text-center p-3">
                          <Button
                            type      = "button"
                            className = "mb-0 mt-0"
                            color     = "success"
                            size      = "md"
                            onClick   = {submitConfigClasses}
                          >Salvar
                          </Button>
                          <Button
                            type      = "button"
                            className = "mb-0 mt-0"
                            color     = "default"
                            size      = "md"
                            onClick   = {()=>{setModalConfig(false)}}
                          >Fechar
                          </Button>
                        </Col>
                      </Row>
                    </ModalFooter>
                  </Modal>

                  <Modal
                    key     = 'modrelat'
                    size    = 'xl'
                    height  = "700px"
                    isOpen  = {modalPrint}
                  >
                    <Iframe
                      allowFullScreen
                      id        = "myId"
                      name      = "myId"
                      className = "myClassname"
                      width     = "100%"
                      height    = "580px"
                      display   = "initial"
                      position  = "relative"
                      url       = {pathPDF}
                      >
                    </Iframe>
                    <Row>
                      <Col className="text-center p-3">
                        <Button
                          type      = "button"
                          className = "mb-0 mt-0"
                          color     = "success"
                          size      = "md"
                          onClick   = {()=>{window.open(pathPDF)}}
                        >Baixar
                        </Button>
                        <Button
                          type      = "button"
                          className = "mb-0 mt-0"
                          color     = "default"
                          size      = "md"
                          onClick   = {()=>{setModalPrint(false)}}
                        >Fechar
                        </Button>
                      </Col>
                    </Row>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CurvaABC;
